import React, { useCallback, useRef } from 'react';

import { VirtualCard as VirtualCardType } from '@generated-types';
import useText from '@hooks/use-text';

import './VirtualCard.scss';

interface VirtualCardProps {
    digitalCard: VirtualCardType;
}

const VirtualCard = ({ digitalCard }: VirtualCardProps) => {
    const text = useText();

    const { digitalCardTitle, digitalCardLeadText } = text;

    const iFrameRef = useRef<HTMLIFrameElement>(null);

    const onLoad = useCallback(() => {
        if (
            digitalCard.imageUrl === undefined ||
            iFrameRef.current === null ||
            iFrameRef.current.contentWindow === null
        ) {
            return;
        }

        iFrameRef.current.contentWindow.window.postMessage(digitalCard.message, new URL(digitalCard.imageUrl).origin);
    }, [digitalCard]);

    return (
        <div>
            <p>{digitalCardLeadText}</p>
            <div className="digital-card-container">
                <iframe
                    title={digitalCardTitle}
                    src={digitalCard.imageUrl}
                    className="digital-card-iframe-element"
                    sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
                    onLoad={onLoad}
                    ref={iFrameRef}
                />
            </div>
        </div>
    );
};

export default VirtualCard;
